var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-menu" },
    [
      _c(
        "vue-client-only",
        [
          _c("accordion", {
            attrs: { items: _vm.items, extendable: _vm.adaptive.isMobile },
            on: { "item-click": _vm.onClick },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function(ref) {
                  var data = ref.data
                  return [
                    data.rating || data.counter
                      ? _c("info-title-params", {
                          attrs: { rating: data.rating, counter: data.counter }
                        })
                      : _vm._e()
                  ]
                }
              },
              {
                key: "default",
                fn: function(ref) {
                  var data = ref.data
                  return [_c(_vm.getComponent(data.key), { tag: "components" })]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }